"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBroadcastRouteMatch = getBroadcastRouteMatch;
exports.getCurrentTeamId = getCurrentTeamId;
exports.getEventIdFromRoute = getEventIdFromRoute;
exports.getEventRouteMatch = getEventRouteMatch;
exports.getPathname = getPathname;
exports.getSearch = getSearch;
exports.getSearchParam = getSearchParam;
exports.getURLSearchParams = getURLSearchParams;
exports.hasEventRouteState = hasEventRouteState;
exports.withCurrentParams = withCurrentParams;
var _reactRouterDom = require("react-router-dom");
var EventPage = "/teams/:teamId/events/:eventId";
var BroadcastPage = "".concat(EventPage, "/broadcasts/:broadcastId");
var Paths = {
  EventPage: EventPage,
  BroadcastPage: BroadcastPage
};
function getPathname(getState) {
  var _getState = getState(),
    router = _getState.router;
  if (!router) return '';
  return router.location.pathname;
}
function getSearch(getState) {
  var _getState2 = getState(),
    router = _getState2.router;
  if (!router) return '';
  return router.location.search;
}
function getURLSearchParams(getState) {
  return new URLSearchParams(getSearch(getState));
}
function getSearchParam(getState, param) {
  return getURLSearchParams(getState).get(param);
}
function getEventRouteMatch(getState) {
  var pathName = getPathname(getState);
  var path = pathName.split('/')[1];
  return (0, _reactRouterDom.matchPath)(pathName, {
    path: "/".concat(path).concat(Paths.EventPage)
  });
}
function getBroadcastRouteMatch(getState) {
  var pathName = getPathname(getState);
  var path = pathName.split('/')[1];
  return (0, _reactRouterDom.matchPath)(pathName, {
    path: "/".concat(path).concat(Paths.BroadcastPage)
  });
}
function getEventIdFromRoute(getState) {
  var _getBroadcastRouteMat = getBroadcastRouteMatch(getState),
    params = _getBroadcastRouteMat.params;
  return params.eventId;
}
function hasEventRouteState(getState) {
  var match = getEventRouteMatch(getState);
  return !!match;
}
function getCurrentTeamId(getState) {
  var teamRouteMatch = getEventRouteMatch(getState);
  if (!teamRouteMatch) return null;
  return teamRouteMatch.params.teamId;
}

/**
 * Helper for executing with current params..
 *
 * @param {*} cb
 */
function withCurrentParams(cb) {
  return function (dispatch, getState, socket) {
    if (hasEventRouteState(getState)) {
      var match = getBroadcastRouteMatch(getState) || getEventRouteMatch(getState);
      cb(dispatch, match.params, getState, socket);
    } else {
      throw new Error('The current route does not have the necessary parameters');
    }
  };
}